module.exports = __webpack_public_path__ + "img/colexo_mac.da22a94c.jpg";